export default "__VITE_ASSET__C6tEc1sH__"